module.exports = "/_next/static/images/e44580c482bef4d3bd0d214c09aa6805-mulher-com-cachos-maravilhosos-segurando-cartao-xs@1x.jpg";